import {CreateInstance} from './config'
const IPPolicyAPI = CreateInstance('ip_policy')
export default IPPolicyAPI
